module.exports = __webpack_public_path__ + "media/images/pen_white-4154f44f.png";